import { MessageFormatElement } from '@formatjs/icu-messageformat-parser';
import { OnErrorFn } from '@formatjs/intl/src/types';
import React, { PropsWithChildren } from 'react';
import { IntlProvider } from 'react-intl';
import { getTranslations } from '../intl/operations';

type Props = PropsWithChildren<{
  onError?: OnErrorFn;
}>;

export const ContainerIntlProvider: React.FC<Props> = ({ children, onError }) => {
  const userLang = navigator.language;
  const locale = userLang?.split('-')[0] ?? 'en';
  const { messages, code } = getTranslations(locale);

  console.log('locale', userLang);

  return (
    <IntlProvider
      locale={code}
      messages={messages as Record<string, string> | Record<string, MessageFormatElement[]>}
      onError={onError}
    >
      {children}
    </IntlProvider>
  );
};
